import styled from 'styled-components'
import { COLOR, FONT_SIZE, IMG } from '../../themes'

export const defaultWidthDisplay = 1440
export const defaultHeightDisplay = 1025
export const WIDTH_SIDEBAR = 250
export const HEIGHT_TOP_BAR = 60

export const StyleCalendar = styled.div`
  overflow: hidden;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: ${COLOR.BLACK_1};
  display: flex;
  flex: 1;
  margin-top: 64px;
  @media screen and (max-width: 1279px) {
    min-width: calc(1280px - 260px);
  }

  .div-content{
    background: transparent;
    color: ${COLOR.GRAY_3};
    height: calc(100% - 46px);
    position: relative;
  }

  .div-content, .div-create{
    width:  100% !important;
    height: 100%;
    overflow: auto;
    display: flex;
  }

  .container {
    justify-content: center;
    width: auto;
    margin: 20px;
    margin-top: 10vh !important;
    width: 100%;
    flex: 4;
    .content-sup-login {
      text-align: center;
      font-size: ${FONT_SIZE.XXS};
      font-weight: 500;
      padding: 8px;
    }
    .content-input-user {
      margin: auto;
      width: 100%;
      text-align: center;
      padding: 6px;
      padding-top: 30px;
    }
    .content-input-pass {
      margin: auto;
      width: 100%;
      text-align: center;
      padding: 4px;
    }
    .button button{
      float: inherit !important;
      line-height: 52px;
      width: 496px;
      margin-top: 30px;
      display: inline-grid;
      background: ${COLOR.BLUE_1};
    }
    .button {
      text-align: center;
    }
    .content-input-checkbox {
      padding-top: 16px;
      padding-bottom: 16px;
      margin: auto;
      width: 100%;
      text-align: left;
      padding-left: 36px;
      label {
        color: ${COLOR.BLACK_3};
        text-align: right;
        clear: both;
        vertical-align: super;
      }
      input {
        -webkit-appearance: none;
        background-color: #fafafa;
        border: 1px solid #cacece;
        // box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -16px 10px -12px rgba(0,0,0,0.05);
        padding: 9px;
        border-radius: 3px;
        display: inline-block;
        position: relative;
      }
      input:active,
      input:checked:active {
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
          inset 0px 1px 3px rgba(0, 0, 0, 0.1);
      }
      input:checked {
        background-color: ${COLOR.BLACK};
        border: 1px solid #adb8c0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
          inset 0px -16px 10px -12px rgba(0, 0, 0, 0.05),
          inset 16px 10px -12px rgba(255, 255, 255, 0.1);
      }
      input:checked:after {
        content: "✔";
        font-size: 14px;
        position: absolute;
        top: 0px;
        left: 3px;
        color: ${COLOR.BLUE_1};
      }

    }
    color: ${COLOR.BLACK_1};
  }
  .bg-login {
    // background: url(${IMG['login_bg1.svg']}) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: ${window.innerHeight}px;
    width: auto;
    color: ${COLOR.GRAY_4};
  }

  .content-head-login {
    color: ${COLOR.GRAY_7};
    font-weight: bold;
    font-size: ${FONT_SIZE.XXXL};
    // position: fixed;
    text-align: center;
  }

  .input {

    border-radius: 4px;
    padding: 6px 10px 6px 26px;
    border: 1px solid ${COLOR.GRAY_6};
    font-size: ${FONT_SIZE.XS};
    outline: none;
    height: 53px;
    width: 496px;
  }

  input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: ${FONT_SIZE.XXS};
    // color: '#999999';
  }

  .sigin {
    margin-top: 30px;
    color: ${COLOR.BLUE_1};
    text-align: center;
  }

`
